import type { JoinGroupForm } from '../join.js';

/** The group ID input, identical on the first-run gate and in Settings (§5). */
export default function GroupIdField({
  form,
  label,
  action,
  hideLabel = false,
}: {
  form: JoinGroupForm;
  label: string;
  action: string;
  /** For the gate, where the card heading already says "group ID" — kept for screen readers. */
  hideLabel?: boolean;
}) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        form.submit();
      }}
    >
      <label className="field">
        <span className={hideLabel ? 'sr-only' : undefined}>{label}</span>
        <input
          className="text-input group-id"
          type="text"
          // No autocorrect or capitalisation help: iOS "helping" with an eight-character
          // code is how you get a rejected ID nobody can see the fault in.
          autoCapitalize="characters"
          autoCorrect="off"
          spellCheck={false}
          autoComplete="off"
          enterKeyHint="go"
          placeholder="Group ID"
          value={form.value}
          disabled={form.pending}
          onChange={(e) => form.setValue(e.target.value)}
        />
      </label>
      {form.error && <p className="error">{form.error}</p>}
      <div className="actions">
        <button type="submit" className="primary" disabled={!form.value || form.pending}>
          {form.pending ? 'Checking…' : action}
        </button>
      </div>
    </form>
  );
}
